import { useContext } from 'react';
import FeatureFlagContext from './FeatureFlagContext';

const useFeatureFlags = () => useContext(FeatureFlagContext);

export default useFeatureFlags;
